// extracted by mini-css-extract-plugin
module.exports = {"root":"OutputsConfig_root__24KGk","title":"OutputsConfig_title__2UTZA"};